var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.25,
    width: 17.5,
    height: 17.5,
    fill: "#32CAFA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.875,
    y: 1.875,
    width: 16.25,
    height: 16.25,
    fill: "#021D25"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 5.75579C5 5.70385 5.11212 5.66396 5.17698 5.66396C5.68662 5.63799 6.4344 5.625 7.21924 5.625C9.41438 5.625 10.2696 6.82902 10.2696 8.37161C10.2696 10.3863 8.81023 11.2499 7.02002 11.2499C6.71979 11.2499 6.61509 11.2369 6.40567 11.2369V14.2832C6.40567 14.349 6.37973 14.375 6.31394 14.375H5.09174C5.02595 14.375 5 14.349 5 14.2832V5.75579ZM6.40567 9.968C6.58821 9.98098 6.73277 9.98098 7.04596 9.98098C7.9735 9.98098 8.84544 9.65354 8.84544 8.39851C8.84544 7.39114 8.22276 6.88096 7.16364 6.88096C6.85045 6.88096 6.5493 6.89395 6.40567 6.90694V9.968ZM13.2228 9.02556C12.5954 9.02556 12.386 9.34002 12.386 9.6016C12.386 9.88915 12.5297 10.0858 13.3664 10.5171C14.608 11.1191 15 11.6943 15 12.5449C15 13.8138 14.0326 14.375 12.7261 14.375C12.0339 14.375 11.4437 14.2349 11.1045 14.0382C11.0526 14.0123 11.0387 13.9733 11.0387 13.9075V12.8584C11.0387 12.7795 11.0777 12.7536 11.1305 12.7925C11.6271 13.12 12.2035 13.2637 12.7261 13.2637C13.3534 13.2637 13.6147 13.0022 13.6147 12.6487C13.6147 12.3612 13.4322 12.1126 12.6344 11.6943C11.5104 11.1581 11.0397 10.608 11.0397 9.6925C11.0397 8.67215 11.8365 7.90294 13.2218 7.90294C13.901 7.90294 14.381 7.92636 14.6423 8.04417C14.7081 8.08313 14.7211 8.14898 14.7211 8.20093V9.28714C14.7211 9.35207 14.6822 9.39196 14.6034 9.36599C14.3514 9.21635 13.8501 9.02556 13.2228 9.02556Z",
    fill: "#32CAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPs);
export default __webpack_public_path__ + "static/media/ps.ea0eda228de42198e53f81f7cf4a3aa4.svg";
export { ForwardRef as ReactComponent };